import React from 'react';
import { Button } from './button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface PaginationControlsProps {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
  className?: string;
}

export function PaginationControls({ page, pageSize, total, onPageChange, className }: PaginationControlsProps) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const clampedPage = Math.min(Math.max(page, 1), totalPages);
  const start = total === 0 ? 0 : (clampedPage - 1) * pageSize + 1;
  const end = Math.min(total, clampedPage * pageSize);

  return (
    <div className={`flex items-center justify-between gap-3 ${className || ''}`}>
      <div className="text-sm text-muted-foreground">
        {total === 0 ? 'No records' : `Showing ${start} - ${end} of ${total}`}
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="ghost"
          size="icon"
          disabled={clampedPage <= 1}
          onClick={() => onPageChange(Math.max(1, clampedPage - 1))}
        >
          <ChevronLeft size={16} />
        </Button>
        <div className="text-sm text-muted-foreground">
          Page {clampedPage} of {totalPages}
        </div>
        <Button
          variant="ghost"
          size="icon"
          disabled={clampedPage >= totalPages}
          onClick={() => onPageChange(Math.min(totalPages, clampedPage + 1))}
        >
          <ChevronRight size={16} />
        </Button>
      </div>
    </div>
  );
}
